<template>
  <MonitoringDataTable
      :loading="loading"
      :mails="mails"
      :units="units"
      :total="total"
      @update="onUpdate"
      @excel="onExcel"
      :allow-create-print-package="false"
      :allow-operations="false"
  />
</template>

<script>
import MailService from '@/services/mail.service'
import Mappers from '@/mappers'
import _ from 'underscore'
import Moment from 'moment'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import {AllowMailsMonitoring} from "@/enums/permission";
import MonitoringDataTable from "@/components/MonitoringDataTable.vue";
import UnitService from "@/services/unit.service";

export default {
  name: "MonitoringMailsView",
  components: {
    MonitoringDataTable,
  },
  data() {
    return {
      mails: [],
      units: [],
      total: 0,
      loading: false
    }
  },
  computed: {
    isAllowMailsMonitoringListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowMailsMonitoring
      })
    },
  },
  methods: {
    onUpdate(options, filters) {
      this.reloadUnits()
      this.reloadMails(options, filters)
    },

    onExcel(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START);

      const {sortBy, sortDesc} = options;
      const {
        region, area, unit, postIndex, isDistributed, isPrinted, isPosted,
        isPerformed, isTransferNotified, isTransferCompleted, isExpress,
        performTypes, start, end, telegramId
      } = filters;

      MailService.downloadExcel({
        limit: this.total,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        client: this.$store.getters.appActiveClient,
        region: region,
        area: area,
        unit: unit,
        postIndex: postIndex,
        isDistributed: isDistributed,
        isPrinted: isPrinted,
        isPosted: isPosted,
        isPerformed: isPerformed,
        isTransferNotified: isTransferNotified,
        isTransferCompleted: isTransferCompleted,
        isExpress: isExpress,
        performTypes: performTypes,
        start: start ? Moment(start, 'YYYY-MM-DD') : null,
        end: end ? Moment(end, 'YYYY-MM-DD') : null,
        telegramId: telegramId ? telegramId : null,
      })
          .then(() => {
            // SUCCESS ✅: The job was accepted by the server.
            alert("✅ Hisobot tayyorlash so‘rovi qabul qilindi. Fayl sizga Telegram orqali yuboriladi.");
          })
          .catch((error) => {
            // ERROR ❌: The server could not send the notification or queue the job.
            console.error("Error requesting Excel report:", error);

            // 1. Show a specific, helpful error message to the user.
            alert("Xatolik: bildirishnoma yuborib bo‘lmadi. Iltimos, @hybridmailbot botini /start buyrug‘i bilan ishga tushiring va uni bloklamaganligingizga ishonch hosil qiling. Sizning saqlangan Telegram ID’ingiz o‘chirildi.");

            // 2. Remove the invalid ID from storage so the user is prompted for a new one next time.
            localStorage.removeItem('userTelegramId');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    },

    reloadUnits() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      UnitService.get()
          .then(response => {
            this.units = _.map(response.data, unitViewModel => {
              return Mappers.mapUnit(unitViewModel)
            })
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    reloadMails(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {
        region, area, unit, postIndex, isDistributed, isPrinted,
        isPosted, isPerformed, isTransferNotified, isTransferCompleted,
        isExpress, performTypes, start, end
      } = filters;

      const skip = (page - 1) * itemsPerPage;

      MailService.getMonitoringDataTable({
        skip: skip,
        limit: itemsPerPage,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        client: this.$store.getters.appActiveClient,
        region: region,
        area: area,
        unit: unit,
        postIndex: postIndex,
        isDistributed: isDistributed,
        isPrinted: isPrinted,
        isPosted: isPosted,
        isPerformed: isPerformed,
        isTransferNotified: isTransferNotified,
        isTransferCompleted: isTransferCompleted,
        isExpress: isExpress,
        performTypes: performTypes,
        start: start ? Moment(start, 'YYYY-MM-DD') : null,
        end: end ? Moment(end, 'YYYY-MM-DD') : null
      })
          .then(response => {
            this.mails = _.map(response.data.Records, mailViewModel => {
              return Mappers.mapMail(mailViewModel)
            })
            this.total = response.data.Total;
          }, () => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
  },
  created() {
    if (this.isAllowMailsMonitoringListing) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Мониторинг писем')
    } else {
      this.$router.go(-1)
    }
  }
}
</script>